import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { actions as authActions } from '../../../actions/authActions';
import AnonymousContentPanel from '../AnonymousContentPanel';
import queryString from 'query-string';
import { Button } from '@material-ui/core';

const AccountActivationPage = ({ authActions, submitting, token }) => (
  <AnonymousContentPanel>
    <p>W systemie Konsultacje JST zostało przygotowane dla Ciebie konto użytkownika, kliknij poniżej aby dokończyć rejestrację</p>
    
    <div>
      <Button
        variant="contained"
        color="primary"
        type="submit"
        className="confirm-button"
        disabled={submitting}
        onClick={() => authActions.activateAccount({ activationToken: token })}
      >
        Aktywuj konto
      </Button>
    </div>
  </AnonymousContentPanel>
);

AccountActivationPage.propTypes = {
  authActions: PropTypes.object.isRequired,
  token: PropTypes.string,
  submitting: PropTypes.bool,
};

function mapDispatchToProps(dispatch) {
  return {
    authActions: bindActionCreators(authActions, dispatch)
  };
}

function mapStateToProps(state, ownProps) {
  const parsed = queryString.parse(ownProps.location.search);

  return {
    token: parsed.token,
    submitting: state.auth.submitting,
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(AccountActivationPage);



// WEBPACK FOOTER //
// ./src/components/auth/accountActivation/AccountActivationPage.js